export const getImpressionWorker = (): Worker =>
  new Worker(
    URL.createObjectURL(
      new Blob(
        [
          '(',

          function (): void {
            const messages: unknown[] = [];

            const BATCH_SEND_DELAY = 200;

            self.onmessage = (event: MessageEvent<string>): void => {
              messages.push(event.data);
            };

            setInterval(() => {
              if (messages.length > 0) {
                const messagesLength = messages.length;
                self.postMessage(messages.slice(0, messagesLength));
                messages.splice(0, messagesLength);
              }
            }, BATCH_SEND_DELAY);
          }.toString(),

          ')()',
        ],
        { type: 'application/javascript' },
      ),
    ),
  );
